import smartToast from '../../util/smart_toast';
import { downloadWithFileName, trataErroBlob } from '../../util/download';
import secureAxios from '../secure_axios';
import toast from 'react-hot-toast';

const baseUrl = 'files'

async function servListarRelatoriosParaDownloadPorTipo(codigoTipoRelatorio) {
    const response = await secureAxios.get(`${baseUrl}/listar/relatorio/por-tipo`, {
        params: { codigoTipoRelatorio }
    })
    return response.data
}

async function servDownloadFilePorFilename(fileName) {
    try {
        const response = await smartToast(
            secureAxios.get(`${baseUrl}/download/por-file-name`, {
                params: { fileName, staticFile: 1 },
                responseType: 'blob'
            })
            , { loadingMessage: 'Baixando Relatório...', apenasLoading: true }
        );
        downloadWithFileName(response);
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

async function servDownloadArquivoPorId(fileId) {
    try {
        const response = await secureAxios.get(`${baseUrl}/download/por-file-id`, {
            params: { fileId },
            responseType: 'blob'
        })
        downloadWithFileName(response);
    } catch (error) {
        trataErroBlob(error);
        throw error
    }
}

async function servDownloadFormularioAcompanhamento(formularioAcompanhamentoId) {
    try {
        const response = await smartToast(
            secureAxios.get('report/formulario-acompanhamento', {
                params: { formularioAcompanhamentoId },
                responseType: 'blob'
            })
            , { loadingMessage: 'Baixando Relatório...', apenasLoading: true }
        );
        downloadWithFileName(response);
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

async function servReciboEnvioIndicadoresMes(mesReferencia) {
    try {
        const response = await smartToast(
            secureAxios.get('report/indicador/recibo', {
                params: { mesReferencia },
                responseType: 'blob'
            })
            , { loadingMessage: 'Baixando Relatório...', apenasLoading: true }
        );
        downloadWithFileName(response);
    } catch (error) {
        console.error(error);
        trataErroBlob(error);
    }
}

export {
    servListarRelatoriosParaDownloadPorTipo,
    servDownloadFilePorFilename,
    servDownloadArquivoPorId,
    servDownloadFormularioAcompanhamento,
    servReciboEnvioIndicadoresMes
}